"use client";
import React, { useEffect, useState } from "react";
import SearchInput from "./SearchInput";
import ProductCard from "./ProductCard";
import TicketDetails from "./TicketDetails";
import { Card, CardBody } from "reactstrap";
import api from "../../utils/api";
import Swal from "sweetalert2";

interface RFIDData {
  bookingDate: string;
  cardAmount: number;
  customerMobileNumber: string;
  customerName: string;
  numberOdAdults: string;
  numberOfChildren: string;
  status: string | null;
  ticketBookingId: number;
  ticketNumber: string;
  ticketRFIdCardRef: string;
  ticketUniqueRFIdNo: string;
}

// Sample product data
// const products = [
//   {
//     id: "1",
//     name: "Pizza",
//     price: 200,
//     image: "https://img.freepik.com/free-photo/pizza-pizza-filled-with-tomatoes-salami-olives_140725-1200.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740",
//   },
//   {
//     id: "2",
//     name: "Doshaa",
//     price: 200,
//     image: "https://img.freepik.com/free-photo/delicious-indian-dosa-composition_23-2149086051.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740",
//   },
//   {
//     id: "3",
//     name: "Fish Curry",
//     price: 200,
//     image: "https://img.freepik.com/free-photo/curry-with-chicken-onions-indian-food-asian-cuisine_2829-6270.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740",
//   },
//   {
//     id: "4",
//     name: "Pizza",
//     price: 200,
//     image: "https://img.freepik.com/free-photo/mixed-pizza-with-various-ingridients_140725-3790.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740",
//   },
//   {
//     id: "5",
//     name: "Doshaa",
//     price: 200,
//     image: "https://img.freepik.com/free-photo/delicious-indian-dosa-composition_23-2149086051.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740",
//   },
//   {
//     id: "6",
//     name: "Fish Curry",
//     price: 200,
//     image: "https://img.freepik.com/premium-photo/seer-fish-curry-indian-fish-curry-arranged-black-bowl-garnished-with-malabar-tamarind_527904-1762.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740",
//   },
// ];


const ProductGrid: React.FC = () => {
  const [filterText, setFilterText] = useState("");
  const [cardNumber, setCardNumber] = useState<string | null>(null);
  const [rfidData, setRfidData] = useState<RFIDData | null>(null);
  const [selectedProducts, setSelectedProducts] = useState<typeof products>([]);
  const [subTotalAmount, setSubTotalAmount] = useState<number>(0);
  const [totalClothes, setTotalClothes] = useState<number>(0);
  const [gstPercent, setGstPercent] = useState<string>("0");
  const [couponCode, setCouponCode] = useState<string>("");
  // State to store discount amount
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const gstAmount = (subTotalAmount * parseFloat(gstPercent)) / 100 || 0;
  const [grandTotalAmount, setGrandTotalAmount] = useState<number>(0);
  const grandTotalAmounts = subTotalAmount + gstAmount - discountAmount;
  useEffect(() => {
    if(grandTotalAmounts < 0) {
      setGrandTotalAmount(0);
    } else {
      setGrandTotalAmount(grandTotalAmounts);
    }
  }, [subTotalAmount, gstAmount, discountAmount]);

  const [products, setProducts] = useState<any[]>([]);

    const fetchAllFoods = async () => {
      try {
        const response = await api.get('/api/FoodMaster/GetAllFoodMaster');
        // Convert response data to desired format
        const formattedData = (response.data || []).map((item: any) => ({
          foodMasterId: item.foodMasterId,
          price: item.sellingprice,
          images: item.images === "NoImage" ? 'https://img.freepik.com/free-photo/pizza-pizza-filled-with-tomatoes-salami-olives_140725-1200.jpg?ga=GA1.1.1294009388.1747470442&semt=ais_hybrid&w=740' : item.images,
          foodItemName: item.foodname,
        }));
        setProducts(formattedData);
      } catch (error) {
        setProducts([]);
      }
    };

  useEffect(() => {
    fetchAllFoods();
  }, []);

  const handleRFIDCardNumber = async (value: string) => {
    setCardNumber(value);
    // console.log("RFID Card Number:", value);
     if(value.length === 10) {
      try {
        const response = await api.get(`/api/RFID/ReadRFID?rfidcardnumber=${value}`);
        if (response.status !== 200) {
            setRfidData(null);
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.data;
        setRfidData(data);
      } catch (error) {
        // console.error('Error fetching RFID data:', error);
        setRfidData(null);
        setCardNumber(null);
      }
    }else{
      setRfidData(null);
      return;
    }
  };

  const handleSelectProduct = (product: typeof products[number]) => {
    setSelectedProducts((prev) =>
      prev.some((p) => p.foodMasterId === product.foodMasterId)
        ? prev.filter((p) => p.foodMasterId !== product.foodMasterId)
        : [...prev, { ...product, quantity: 1, foodOrderItemId: 0, foodOrderId: 0 }]
    );
    // Calculate total amount after selection
    const updatedProducts = selectedProducts.some((p) => p.foodMasterId === product.foodMasterId)
      ? selectedProducts.filter((p) => p.foodMasterId !== product.foodMasterId)
      : [...selectedProducts, { ...product, quantity: 1 }];
    const subTotalAmount = updatedProducts.reduce((sum, p) => sum + p.price * (p.quantity || 1), 0);
    setSubTotalAmount(subTotalAmount);
    const totalQuantity = updatedProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);
    setTotalClothes(totalQuantity);
  };

  const confirmpay = async () => {
    try {
      if (!cardNumber || cardNumber.toString().length !== 10) {
        Swal.fire('Error!', 'Please enter a valid RF ID Card number.', 'error');
        return;
      }
      if (selectedProducts.length === 0) {
        Swal.fire('Error!', 'Please select at least one item.', 'error');
        return;
      }
      if(rfidData === null || rfidData?.ticketRFIdCardRef === null || rfidData?.ticketRFIdCardRef === undefined) {
        Swal.fire('Error!', 'Please scan a valid RF ID Card.', 'error');
        return;
      }
      if(rfidData?.cardAmount === undefined || rfidData?.cardAmount === null || rfidData?.cardAmount <= 0) {
        Swal.fire('Error!', 'Insufficient Balance or Invalid Card Amount.', 'error');
        return;
      }
      if (rfidData && rfidData?.cardAmount >= 0) {
        if (rfidData.cardAmount < grandTotalAmount) {
          Swal.fire('Error!', 'Insufficient Balance!!', 'error');
        }
      }
      const result = await Swal.fire({
        title: 'Confirm Food Order Payment',
        html: `
            <div style="text-align:left">
              <p>Do you want to pay <b>₹${grandTotalAmount}</b> for food(s)?</p>
              <p><b>Ticket No.:</b> ${rfidData?.ticketRFIdCardRef}</p>
              <p><b>Customer Number:</b> ${rfidData?.customerMobileNumber}</p>
              <p><b>Selected Card ID:</b> ${cardNumber}</p>
              <p><b>Total Quantity(s):</b> ${totalClothes}</p>
              <p><b>Sub Total:</b> ₹${subTotalAmount}</p>
              <p><b>GST (${gstPercent}%):</b> ₹${gstAmount.toFixed(2)}</p>
              <p><b>Discount:</b> ₹${discountAmount.toFixed(2)}</p>
              <p><b>Grand Total:</b> ₹${grandTotalAmount.toFixed(2)}</p>
              <p><b>Current Balance:</b> ₹${rfidData?.cardAmount}</p>
            </div>
              `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Pay',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        // Place recharge logic here
        try {
          // Here you can send the selected products to your API or perform any other action
          const submittedData = {
            foodOrderId: 0,
            subTotalAmount: subTotalAmount,
            gst: gstAmount,
            grandTotalAmount: grandTotalAmount,
            ticketRFIdRef: rfidData?.ticketRFIdCardRef, // or make this dynamic if needed
            cardNumber: cardNumber,
            coupanCode: couponCode,
            discountAmount: discountAmount,
            messege: "",
            staffUserid: JSON.parse(localStorage.getItem('user')!).userId,
            counterid: JSON.parse(localStorage.getItem('user')!).counterid,
            foodOrders: selectedProducts.map(product => ({
              foodOrderItemId: 0,
              foodItemName: product.foodItemName,
              quantity: product.quantity ?? 1,
              foodOrderId: 0,
              price: product.price
            }))
          };

          // console.log("Submitted Data:", submittedData);
          try {
            const response = await api.post(
              '/api/FoodOrder/AddFoodOrder',
              submittedData,
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': '*/*'
                }
              }
            );

            // console.log("✅ API response:", response.data);
            if (response.status === 200) {
              setSelectedProducts([]);
              setSubTotalAmount(0);
              setTotalClothes(0);
              setGstPercent("0");
              setCardNumber(null);
              // (document.querySelector('input[id="rfid-input"]') as HTMLInputElement).value = "";
              if(response.data.foodOrderId === 0){
                Swal.fire({
                  icon: 'error',
                  title: 'Food order Failed',
                  text: response.data.messege,
                });
                return;
              }
              Swal.fire({
                icon: 'success',
                title: "Food Order Successful",
                text: 'Successfully Ordered.',
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Food order Failed',
                text: 'Failed to order food',
              });
            }
          } catch (error) {
            if (error && typeof error === "object" && "response" in error) {
              // @ts-ignore
              // console.error("❌ API error:", error.response?.data || error.message);
              Swal.fire({
                icon: 'error',
                title: 'Food order Failed',
                text: 'Failed to order food',
              });
            } else {
              // console.error("❌ API error:", error);
              Swal.fire({
                icon: 'error',
                title: 'Food order Failed',
                text: 'Failed to order food',
              });
            }
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Food order Failed',
            text: error instanceof Error ? error.message : 'Something went wrong while order food.',
          });
        }

      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to order food.', 'error');
    }
  }

  async function couponApply() {
    if (!couponCode) {
      Swal.fire({
        icon: 'warning',
        title: 'No Coupon Code',
        text: 'Please enter a coupon code.',
      });
      return;
    }
    try {
      const response = await api.put(`/api/Coupan/CoupanApply?coupanCode=${couponCode}`);
      if (response.status === 200) {
        const couponAmount = response.data.discountAmount || 0;
        if (couponAmount > 0) {
          setDiscountAmount(couponAmount);
          Swal.fire({
            icon: 'success',
            title: 'Coupon Applied',
            text: `Discount of ₹${couponAmount} applied.`,
          });
        } else {
          setDiscountAmount(0);
          Swal.fire({
            icon: 'info',
            title: 'Coupon Not Applicable',
            text: response.data.message || 'This coupon code is invalid or expired.',
          });
        }
      } else {
        setDiscountAmount(0);
        Swal.fire({
          icon: 'error',
          title: 'Invalid Coupon',
          text: 'The coupon code is invalid or expired.',
        });
      }
    } catch (error) {
      setDiscountAmount(0);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error instanceof Error ? error.message : 'Failed to validate coupon code.',
      });
    }
  }

  function filterProducts(foodvalue: string) {
    if(foodvalue) {
      setProducts(products.filter((item) =>
        item.foodItemName.toLowerCase().includes(foodvalue.toLowerCase())
      ));
    }else{
      fetchAllFoods();
    }
  }

  return (
    <>
      <Card>
        <header className="bg-white px-4 py-4 fs-5 fw-semibold text-dark border">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Enter your RF ID Card number..."
              aria-label="Enter your RF ID Card number"
              aria-describedby="scan-button"
              onChange={(e) => {
                const value = e.target.value;
                // if (value.length === 10) {
                  handleRFIDCardNumber(value);
                // }
              }}
              value={cardNumber ? cardNumber.toString() : ""}
            />
            <button className="btn btn-outline-secondary" type="button" id="scan-button">
              Scan RF ID
            </button>
          </div>
        </header>
        <CardBody>
          <div className="container">
            <div className="row gy-4">
              {/* Product Grid Column */}
              <div className="col-lg-8 col-md-12">
                <section className="p-3">
                  <div className="mb-4">
                    <header className="bg-white px-4 py-4 fs-5 fw-semibold text-dark border mb-4">
                      <div className="input-group">
                        <input
                          className="form-control"
                          placeholder="Search Food..."
                          aria-label="Search food by name"
                          aria-describedby="search-button"
                          type="search"
                          value={filterText}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                            { 
                              const foodvalue = e.target.value;
                              setFilterText(foodvalue);
                              filterProducts(foodvalue);
                            }}
                          autoComplete="off"
                        />
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          id="search-button"
                        >
                          <i className="fa fa-search"></i>
                        </button>
                      </div>
                    </header>
                  </div>
                  <div className="row g-4">
                    {products.length === 0 ? (
                      <div className="col-12 text-center text-muted py-5">
                        No Item found
                      </div>
                    ) : (
                      products.map((product) => (
                      <div key={product.foodMasterId}  onClick={() => handleSelectProduct(product)} className="col-md-4">
                        <div
                          style={{
                            border: selectedProducts.some((p) => p.foodMasterId === product.foodMasterId)
                              ? "2px solid #007bff"
                              : "",
                            borderRadius: "8px",
                            cursor: "pointer",
                            transition: "border 0.2s"
                          }}
                        >
                          <article className="card shadow-sm">
                            <img
                              src={product.images}
                              alt={product.foodItemName}
                              className="card-img-top rounded-top"
                              style={{ height: "12rem", objectFit: "cover" }}
                            />
                            <div className="card-body">
                              <h5 className="card-title">{product.foodItemName}</h5>
                              <p className="card-text text-muted">₹ {product.price}</p>
                            </div>
                          </article>
                        </div>
                      </div>
                     ))
                    )}
                  </div>
                </section>
              </div>

              {/* Ticket Details Column */}
              <div className="col-lg-4 col-md-12">
                <aside className="border border-5 border-warning bg-light text-dark small px-2 pt-4 pb-5 mt-3 w-100">
                  <h2 className="text-center fw-semibold fs-5 mb-3">Ticket Details</h2>

                  <div className="mx-auto" style={{ maxWidth: "200px" }}>
                    <p>Ticket No.-{rfidData?.ticketNumber}</p>
                    <p className="mt-2">Customer Name-{rfidData?.customerName}</p>
                    <p className="mt-2">Customer Number-{rfidData?.customerMobileNumber}</p>
                    <p className="mt-2">Total Members - {Number(rfidData?.numberOdAdults) + Number(rfidData?.numberOfChildren)}</p>
                    <p className="mt-2">No. of Adults - {rfidData?.numberOdAdults}</p>
                    <p className="mt-2">Kids - {rfidData?.numberOfChildren}</p>
                    <p className="mt-2">Card Assign - xxxxxxxxxxxxxxxxx</p>
                    <p className="mt-2">Select Card ID - {cardNumber}</p>
                    <p className="mt-2">Balance - {rfidData?.cardAmount}</p>
                  </div>

                  <div className="mt-4">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/1941f8873fe07e7c780902338a50e0fd17627aae?placeholderIfAbsent=true&apiKey=155088335b9245cc9e899591d6dc52ea"
                      alt="Divider"
                      className="img-fluid"
                    />
                  </div>

                  <h3 className="text-center mt-3 fw-semibold">Calculations</h3>

                  <div className="mt-3 ms-4">
                    <p className="mb-2">Total Item(s) - {totalClothes}</p>
                    {selectedProducts.length === 0 ? (
                      <div className="text-muted mb-2">No item selected</div>
                    ) : (
                      selectedProducts.map((product) => (
                        <div className="d-flex align-items-center justify-content-between mb-2" key={product.foodMasterId}>
                          <span>
                            {product.foodItemName}
                          </span>
                          <div className="d-flex align-items-center gap-2">
                            <button
                              className="btn btn-outline-secondary btn-sm px-2 py-0"
                              onClick={() => {
                                setSelectedProducts((prev) =>
                                  prev
                                    .map((p) =>
                                      p.foodMasterId === product.foodMasterId
                                        ? { ...p, quantity: Math.max((p.quantity || 1) - 1, 1) }
                                        : p
                                    )
                                    .filter((p) => (p.foodMasterId === product.foodMasterId ? (product.quantity || 1) > 1 : true))
                                );
                                // Update subtotal and quantity
                                const updatedProducts = selectedProducts
                                  .map((p) =>
                                    p.foodMasterId === product.foodMasterId
                                      ? { ...p, quantity: Math.max((p.quantity || 1) - 1, 1) }
                                      : p
                                  )
                                  .filter((p) => (p.foodMasterId === product.foodMasterId ? (product.quantity || 1) > 1 : true));
                                const subTotalAmount = updatedProducts.reduce((sum, p) => sum + p.price * (p.quantity || 1), 0);
                                setSubTotalAmount(subTotalAmount);
                                const totalQuantity = updatedProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);
                                setTotalClothes(totalQuantity);
                              }}
                              disabled={(product.quantity || 1) <= 1}
                            >
                              -
                            </button>
                            <span>{product.quantity || 1}</span>
                            <button
                              className="btn btn-outline-secondary btn-sm px-2 py-0"
                              onClick={() => {
                                setSelectedProducts((prev) =>
                                  prev.map((p) =>
                                    p.foodMasterId === product.foodMasterId
                                      ? { ...p, quantity: (p.quantity || 1) + 1 }
                                      : p
                                  )
                                );
                                // Update subtotal and quantity
                                const updatedProducts = selectedProducts.map((p) =>
                                  p.foodMasterId === product.foodMasterId
                                    ? { ...p, quantity: (p.quantity || 1) + 1 }
                                    : p
                                );
                                const subTotalAmount = updatedProducts.reduce((sum, p) => sum + p.price * (p.quantity || 1), 0);
                                setSubTotalAmount(subTotalAmount);
                                const totalQuantity = updatedProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);
                                setTotalClothes(totalQuantity);
                              }}
                            >
                              +
                            </button>
                            <span>Rs. {product.price * (product.quantity || 1)}</span>
                          </div>
                        </div>
                      ))
                    )}
                    <p className="mt-3">Sub Total Amount - {subTotalAmount}</p>
                    <div className="d-flex align-items-center justify-content-between mt-2 mb-2" style={{ maxWidth: "160px" }}>
                      <span className="me-2">GST -</span>
                      <input
                        type="text"
                        className="form-control form-control-sm bg-white px-3 py-1 rounded-pill fw-normal"
                        style={{ width: "100px" }}
                        placeholder="GST %"
                        min={0}
                        max={100}
                        value={gstPercent}
                        onChange={(e) => setGstPercent(e.target.value)}
                      />
                    </div>
                    <p>GST Amount - {gstAmount}</p>
                  </div>
                  <div className="mt-3 ms-4">
                    <label htmlFor="coupon-code" className="form-label fw-semibold">
                      Coupon Code
                    </label>
                    <div className="input-group mb-2" style={{ maxWidth: "250px" }}>
                      <input
                      type="text"
                      id="coupon-code"
                      className="form-control form-control-sm rounded-start"
                      placeholder="Enter coupon code"
                      value={couponCode}
                      onChange={async (e) => {
                        const value = e.target.value;
                        setCouponCode(value);
                      }}
                      />
                      <button
                      className="btn btn-outline-success btn-sm rounded-end"
                      type="button"
                      disabled={!couponCode}
                      onClick={async () => { couponApply() }}
                      >
                      Apply
                      </button>
                    </div>
                  </div>
                  <div className="mt-3 ms-4">
                    <p className="mt-2">Grand Total Amount - {grandTotalAmount}</p>
                  </div>
                  <div className="text-center mt-5">
                    <button className="btn btn-primary px-5 py-2 rounded-pill fw-semibold" onClick={confirmpay}>
                      Pay
                    </button>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </>

  );
};

export default ProductGrid;